import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginRight: 'unset',
  marginLeft: 'unset',
  boxSizing: 'unset',
  padding: 0,
  ['@media(min-width: 600px)']: {
    padding: 0,
  },
}));

export default StyledContainer;
